export default Object.freeze({
    LANGUAGE_CODE_API: 'en',
    INDEX_API: 0,
    PAGE_SIZE_API: 10,
    UNIQUE_IDENTIFIER_API_KEY: process.env.VUE_APP_NEWS_FEED_UNIQUE_IDENTIFIER_KEY
});